// Lead triage vocabulary (#476) — the human working state an operator sets in
// the inbox, a separate axis from the funnel's own `status`. Mirrors
// hd-api storage/lead.py TRIAGE_STATUSES; the server validates against the same
// set, so keep the two in sync.
//
// Two terminal states kept apart on purpose: `lost` is a real inquiry we didn't
// win; `disqualified` was never a real inquiry (spam, out of area, wrong
// service). They differ in the conversion-rate denominator, so collapsing them
// would make that metric lie.

export const TRIAGE_STATUSES = [
  "new",
  "working",
  "nurturing",
  "lost",
  "disqualified",
] as const;

export type TriageStatus = (typeof TRIAGE_STATUSES)[number];

export const TRIAGE_LABEL: Record<TriageStatus, string> = {
  new: "New",
  working: "Working",
  nurturing: "Nurturing",
  lost: "Lost",
  disqualified: "Disqualified",
};

// Badge palette, drawn from the same tokens as LeadStateBadge. new (tide) reads
// as untouched; working (spark) as active; nurturing (sage) as parked-but-alive;
// lost (rust) as a real inquiry we didn't win; disqualified (grey) as never real.
export const TRIAGE_BADGE_CLASS: Record<TriageStatus, string> = {
  new: "text-tide-d bg-tide-ss",
  working: "text-spark bg-spark-s",
  nurturing: "text-sage bg-sage-s",
  lost: "text-rust bg-rust-s",
  disqualified: "text-ink-4 bg-canvas-2",
};

export function isTriageStatus(value: string): value is TriageStatus {
  return (TRIAGE_STATUSES as readonly string[]).includes(value);
}
